(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babel-runtime/helpers/classCallCheck"), require("babel-runtime/core-js/object/get-prototype-of"), require("babel-runtime/helpers/inherits"), require("babel-runtime/helpers/possibleConstructorReturn"), require("babel-runtime/helpers/createClass"), require("babel-runtime/core-js/json/stringify"), require("babel-runtime/core-js/object/keys"), require("babel-runtime/core-js/object/assign"), require("babel-runtime/helpers/get"), require("babel-runtime/helpers/typeof"), require("jszip"), require("to-xml"));
	else if(typeof define === 'function' && define.amd)
		define(["babel-runtime/helpers/classCallCheck", "babel-runtime/core-js/object/get-prototype-of", "babel-runtime/helpers/inherits", "babel-runtime/helpers/possibleConstructorReturn", "babel-runtime/helpers/createClass", "babel-runtime/core-js/json/stringify", "babel-runtime/core-js/object/keys", "babel-runtime/core-js/object/assign", "babel-runtime/helpers/get", "babel-runtime/helpers/typeof", "jszip", "to-xml"], factory);
	else if(typeof exports === 'object')
		exports["jsdocx"] = factory(require("babel-runtime/helpers/classCallCheck"), require("babel-runtime/core-js/object/get-prototype-of"), require("babel-runtime/helpers/inherits"), require("babel-runtime/helpers/possibleConstructorReturn"), require("babel-runtime/helpers/createClass"), require("babel-runtime/core-js/json/stringify"), require("babel-runtime/core-js/object/keys"), require("babel-runtime/core-js/object/assign"), require("babel-runtime/helpers/get"), require("babel-runtime/helpers/typeof"), require("jszip"), require("to-xml"));
	else
		root["jsdocx"] = factory(root["babel-runtime/helpers/classCallCheck"], root["babel-runtime/core-js/object/get-prototype-of"], root["babel-runtime/helpers/inherits"], root["babel-runtime/helpers/possibleConstructorReturn"], root["babel-runtime/helpers/createClass"], root["babel-runtime/core-js/json/stringify"], root["babel-runtime/core-js/object/keys"], root["babel-runtime/core-js/object/assign"], root["babel-runtime/helpers/get"], root["babel-runtime/helpers/typeof"], root["jszip"], root["to-xml"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_41__, __WEBPACK_EXTERNAL_MODULE_42__, __WEBPACK_EXTERNAL_MODULE_43__, __WEBPACK_EXTERNAL_MODULE_44__, __WEBPACK_EXTERNAL_MODULE_45__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Element = __webpack_require__(2);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _Text = __webpack_require__(15);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _RunFormat = __webpack_require__(12);
	
	var _RunFormat2 = _interopRequireDefault(_RunFormat);
	
	var _Run = __webpack_require__(11);
	
	var _Run2 = _interopRequireDefault(_Run);
	
	var _ParagraphFormat = __webpack_require__(10);
	
	var _ParagraphFormat2 = _interopRequireDefault(_ParagraphFormat);
	
	var _Paragraph = __webpack_require__(7);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _TableFormat = __webpack_require__(14);
	
	var _TableFormat2 = _interopRequireDefault(_TableFormat);
	
	var _Table = __webpack_require__(8);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _File = __webpack_require__(9);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _Document = __webpack_require__(18);
	
	var _Document2 = _interopRequireDefault(_Document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Element: _Element2.default,
	  Text: _Text2.default,
	  RunFormat: _RunFormat2.default,
	  Run: _Run2.default,
	  ParagraphFormat: _ParagraphFormat2.default,
	  Paragraph: _Paragraph2.default,
	  TableFormat: _TableFormat2.default,
	  Table: _Table2.default,
	  Section: _Section2.default,
	  File: _File2.default,
	  Document: _Document2.default
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/classCallCheck");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(17);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(43);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(41);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _toXml = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function () {
	  function _class(src, contenthook, contents) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    this.src = src || {};
	    this.contentHook = contenthook || null;
	    this.contents = contents || [];
	    if (this.contentHook && ['.', '['].indexOf(this.contentHook[0]) === -1) {
	      throw TypeError('First char of content hook should be "." or "["');
	    }
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {}
	  }, {
	    key: 'toJson',
	    value: function toJson() {
	      var src = (0, _assign2.default)({}, this.src);
	      var contents = this.contents.slice(0);
	
	      this.finalize(contents);
	
	      var realContents = contents.filter(function (c) {
	        return c && (c instanceof String || (typeof c === 'undefined' ? 'undefined' : (0, _typeof3.default)(c)) === 'object');
	      });
	
	      if (this.contentHook && realContents.length > 0) {
	        var cntHookPath = this.contentHook;
	        if (cntHookPath.endsWith('["#"]')) {
	          cntHookPath = cntHookPath.splice(0, cntHookPath.length - 5);
	        }
	        var hook = eval('src' + cntHookPath);
	        if ((typeof hook === 'undefined' ? 'undefined' : (0, _typeof3.default)(hook)) === 'object') {
	          if ((0, _keys2.default)(hook).indexOf('#') === -1) {
	            hook['#'] = [];
	          }
	          var hookCnt = hook['#'];
	          if (!(hookCnt instanceof Array)) {
	            hook['#'] = [hookCnt].filter(function (i) {
	              return i !== null;
	            });
	          }
	          realContents.forEach(function (c) {
	            if (c && c.toJson) {
	              var json = c.toJson();
	              hook['#'].push(json);
	            }
	          });
	        }
	      }
	
	      return JSON.parse((0, _stringify2.default)(src));
	    }
	  }, {
	    key: 'toXml',
	    value: function toXml() {
	      return (0, _toXml.toXML)(this.toJson());
	    }
	  }]);
	  return _class;
	}();

	exports.default = _class;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/object/get-prototype-of");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/inherits");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/createClass");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _ParagraphFormat = __webpack_require__(10);
	
	var _ParagraphFormat2 = _interopRequireDefault(_ParagraphFormat);
	
	var _Run = __webpack_require__(11);
	
	var _Run2 = _interopRequireDefault(_Run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(format) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:p': {} }, '["w:p"]'));
	
	    _this.setFormat(format || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {
	      if (this.format) contents.unshift(this.format);
	    }
	  }, {
	    key: 'addFormat',
	    value: function addFormat() {
	      var fmt = new _ParagraphFormat2.default();
	      this.setFormat(fmt);
	      return fmt;
	    }
	  }, {
	    key: 'setFormat',
	    value: function setFormat(value) {
	      if (!(value instanceof _ParagraphFormat2.default || value === null)) {
	        throw TypeError('Invalid Paragraph.format');
	      }
	      this.format = value;
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      return this.format;
	    }
	  }, {
	    key: 'addRun',
	    value: function addRun() {
	      var r = new _Run2.default();
	      this.contents.push(r);
	      return r;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _TableFormat = __webpack_require__(14);
	
	var _TableFormat2 = _interopRequireDefault(_TableFormat);
	
	var _TableHeader = __webpack_require__(38);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _TableRow = __webpack_require__(40);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(format, header) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tbl': {} }, '["w:tbl"]'));
	
	    _this.setFormat(format || null);
	    _this.setHeader(header || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {
	      if (this.header) contents.unshift(this.header);
	      if (this.format) contents.unshift(this.format);
	    }
	  }, {
	    key: 'addFormat',
	    value: function addFormat() {
	      var fmt = new _TableFormat2.default();
	      this.setFormat(fmt);
	      return fmt;
	    }
	  }, {
	    key: 'setFormat',
	    value: function setFormat(value) {
	      if (!(value instanceof _TableFormat2.default || value === null)) {
	        throw TypeError('Invalid Table.format');
	      }
	      this.format = value;
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      return this.format;
	    }
	  }, {
	    key: 'addHeader',
	    value: function addHeader() {
	      var header = new _TableHeader2.default();
	      this.setHeader(header);
	      return header;
	    }
	  }, {
	    key: 'setHeader',
	    value: function setHeader(value) {
	      if (!(value instanceof _TableHeader2.default || value === null)) {
	        throw TypeError('Invalid Table.header');
	      }
	      this.header = value;
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return this.header;
	    }
	  }, {
	    key: 'addRow',
	    value: function addRow() {
	      var row = new _TableRow2.default();
	      this.contents.push(row);
	      return row;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);

	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));
	  }

	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _ParagraphIndentation = __webpack_require__(22);
	
	var _ParagraphIndentation2 = _interopRequireDefault(_ParagraphIndentation);
	
	var _ParagraphKeepLines = __webpack_require__(23);
	
	var _ParagraphKeepLines2 = _interopRequireDefault(_ParagraphKeepLines);
	
	var _ParagraphKeepNext = __webpack_require__(24);
	
	var _ParagraphKeepNext2 = _interopRequireDefault(_ParagraphKeepNext);
	
	var _ParagraphSpacing = __webpack_require__(26);
	
	var _ParagraphSpacing2 = _interopRequireDefault(_ParagraphSpacing);
	
	var _ParagraphTabs = __webpack_require__(28);
	
	var _ParagraphTabs2 = _interopRequireDefault(_ParagraphTabs);
	
	var _ParagraphHAlignment = __webpack_require__(21);
	
	var _ParagraphHAlignment2 = _interopRequireDefault(_ParagraphHAlignment);
	
	var _ParagraphVAlignment = __webpack_require__(29);
	
	var _ParagraphVAlignment2 = _interopRequireDefault(_ParagraphVAlignment);
	
	var _ParagraphShading = __webpack_require__(25);
	
	var _ParagraphShading2 = _interopRequireDefault(_ParagraphShading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(indentation, keepNext, keepLines, spacing, tabs, hAlignment, vAlignment, shading) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:pPr': {} }, '["w:pPr"]'));
	
	    _this.setIndentation(indentation || null);
	    _this.setKeepNext(keepNext || null);
	    _this.setKeepLines(keepLines || null);
	    _this.setSpacing(spacing || null);
	    _this.setTabs(tabs || null);
	    _this.setHAlignment(hAlignment || null);
	    _this.setVAlignment(vAlignment || null);
	    _this.setShading(shading || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {
	      if (this.indentation) contents.push(this.indentation);
	      if (this.keepLines) contents.push(this.keepLines);
	      if (this.keepNext) contents.push(this.keepNext);
	      if (this.spacing) contents.push(this.spacing);
	      if (this.tabs) contents.push(this.tabs);
	      if (this.hAlignment) contents.push(this.hAlignment);
	      if (this.vAlignment) contents.push(this.vAlignment);
	      if (this.shading) contents.push(this.shading);
	    }
	  }, {
	    key: 'addIndentation',
	    value: function addIndentation() {
	      var ind = new _ParagraphIndentation2.default();
	      this.setIndentation(ind);
	      return ind;
	    }
	  }, {
	    key: 'setIndentation',
	    value: function setIndentation(value) {
	      if (!(value instanceof _ParagraphIndentation2.default || value === null)) {
	        throw TypeError('Invalid ParagraphFormat.indentation');
	      }
	      this.indentation = value;
	    }
	  }, {
	    key: 'getIndentation',
	    value: function getIndentation() {
	      return this.indentation;
	    }
	  }, {
	    key: 'addKeepLines',
	    value: function addKeepLines() {
	      var kl = new _ParagraphKeepLines2.default();
	      this.setKeepLines(kl);
	      return kl;
	    }
	  }, {
	    key: 'setKeepLines',
	    value: function setKeepLines(value) {
	      if (!(value instanceof _ParagraphKeepLines2.default || value === null || value === true)) {
	        throw TypeError('Invalid ParagraphFormat.keepLines');
	      }
	      if (value === true) {
	        value = new _ParagraphKeepLines2.default();
	      }
	      this.keepLines = value;
	    }
	  }, {
	    key: 'getKeepLines',
	    value: function getKeepLines() {
	      return this.keepLines;
	    }
	  }, {
	    key: 'addKeepNext',
	    value: function addKeepNext() {
	      var kn = new _ParagraphKeepNext2.default();
	      this.setKeepNext(kn);
	      return kn;
	    }
	  }, {
	    key: 'setKeepNext',
	    value: function setKeepNext(value) {
	      if (!(value instanceof _ParagraphKeepNext2.default || value === null || value === true)) {
	        throw TypeError('Invalid ParagraphFormat.keepNext');
	      }
	      if (value === true) {
	        value = new _ParagraphKeepNext2.default();
	      }
	      this.keepNext = value;
	    }
	  }, {
	    key: 'getKeepNext',
	    value: function getKeepNext() {
	      return this.keepNext;
	    }
	  }, {
	    key: 'addSpacing',
	    value: function addSpacing() {
	      var s = new _ParagraphSpacing2.default();
	      this.setSpacing(s);
	      return s;
	    }
	  }, {
	    key: 'setSpacing',
	    value: function setSpacing(value) {
	      if (!(value instanceof _ParagraphSpacing2.default || value === null)) {
	        throw TypeError('Invalid ParagraphFormat.spacing');
	      }
	      this.spacing = value;
	    }
	  }, {
	    key: 'getSpacing',
	    value: function getSpacing() {
	      return this.spacing;
	    }
	  }, {
	    key: 'addTabs',
	    value: function addTabs() {
	      var ts = new _ParagraphTabs2.default();
	      this.setTabs(ts);
	      return ts;
	    }
	  }, {
	    key: 'setTabs',
	    value: function setTabs(value) {
	      if (!(value instanceof _ParagraphTabs2.default || value === null)) {
	        throw TypeError('Invalid ParagraphFormat.tabs');
	      }
	      this.tabs = value;
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      return this.tabs;
	    }
	  }, {
	    key: 'addHAlignment',
	    value: function addHAlignment() {
	      var ha = new _ParagraphHAlignment2.default();
	      this.setHAlignment(ha);
	      return ha;
	    }
	  }, {
	    key: 'setHAlignment',
	    value: function setHAlignment(value) {
	      if (!(value instanceof _ParagraphHAlignment2.default || value === null)) {
	        throw TypeError('Invalid ParagraphFormat.hAlignment');
	      }
	      this.hAlignment = value;
	    }
	  }, {
	    key: 'getHAlignment',
	    value: function getHAlignment() {
	      return this.hAlignment;
	    }
	  }, {
	    key: 'addVAlignment',
	    value: function addVAlignment() {
	      var va = new _ParagraphVAlignment2.default();
	      this.setVAlignment(va);
	      return va;
	    }
	  }, {
	    key: 'setVAlignment',
	    value: function setVAlignment(value) {
	      if (!(value instanceof _ParagraphVAlignment2.default || value === null)) {
	        throw TypeError('Invalid ParagraphFormat.vAlignment');
	      }
	      this.vAlignment = value;
	    }
	  }, {
	    key: 'getVAlignment',
	    value: function getVAlignment() {
	      return this.vAlignment;
	    }
	  }, {
	    key: 'addShading',
	    value: function addShading() {
	      var sh = new _ParagraphShading2.default();
	      this.setShading(sh);
	      return sh;
	    }
	  }, {
	    key: 'setShading',
	    value: function setShading(value) {
	      if (!(value instanceof _ParagraphShading2.default || value === null)) {
	        throw TypeError('Invalid ParagraphFormat.shading');
	      }
	      this.shading = value;
	    }
	  }, {
	    key: 'getShading',
	    value: function getShading() {
	      return this.shading;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _RunFormat = __webpack_require__(12);
	
	var _RunFormat2 = _interopRequireDefault(_RunFormat);
	
	var _RunBreak = __webpack_require__(31);
	
	var _RunBreak2 = _interopRequireDefault(_RunBreak);
	
	var _Text = __webpack_require__(15);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(format) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:r': {} }, '["w:r"]'));
	
	    _this.setFormat(format || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {
	      if (this.format) contents.unshift(this.format);
	    }
	  }, {
	    key: 'addFormat',
	    value: function addFormat() {
	      var fmt = new _RunFormat2.default();
	      this.setFormat(fmt);
	      return fmt;
	    }
	  }, {
	    key: 'setFormat',
	    value: function setFormat(value) {
	      if (!(value instanceof _RunFormat2.default || value === null)) {
	        throw TypeError('Invalid Run.format');
	      }
	      this.format = value;
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      return this.format;
	    }
	  }, {
	    key: 'addText',
	    value: function addText(str) {
	      var t = new _Text2.default(str);
	      this.contents.push(t);
	      return t;
	    }
	  }, {
	    key: 'addBreak',
	    value: function addBreak(type) {
	      var rb = new _RunBreak2.default(type);
	      this.contents.push(rb);
	      return rb;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _RunBold = __webpack_require__(30);
	
	var _RunBold2 = _interopRequireDefault(_RunBold);
	
	var _RunItalic = __webpack_require__(34);
	
	var _RunItalic2 = _interopRequireDefault(_RunItalic);
	
	var _RunFonts = __webpack_require__(33);
	
	var _RunFonts2 = _interopRequireDefault(_RunFonts);
	
	var _RunColor = __webpack_require__(32);
	
	var _RunColor2 = _interopRequireDefault(_RunColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(bold, italic, fonts, color) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:rPr': {} }, '["w:rPr"]'));
	
	    if (bold) _this.setBold(bold || null);
	    if (italic) _this.setItalic(italic || null);
	    if (fonts) _this.setFonts(fonts || null);
	    if (color) _this.setColor(color || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {
	      if (this.bold) contents.push(this.bold);
	      if (this.italic) contents.push(this.italic);
	      if (this.fonts) contents.push(this.fonts);
	      if (this.color) contents.push(this.color);
	    }
	  }, {
	    key: 'addBold',
	    value: function addBold() {
	      var rb = new _RunBold2.default();
	      this.setBold(rb);
	      return rb;
	    }
	  }, {
	    key: 'setBold',
	    value: function setBold(value) {
	      if (!(value instanceof _RunBold2.default || value === true || value === null)) {
	        throw TypeError('Invalid RunFormat.bold');
	      }
	      if (value) {
	        value = new _RunBold2.default();
	      }
	      this.bold = value;
	    }
	  }, {
	    key: 'getBold',
	    value: function getBold() {
	      return this.bold;
	    }
	  }, {
	    key: 'addItalic',
	    value: function addItalic() {
	      var ri = new _RunItalic2.default();
	      this.setItalic(ri);
	      return ri;
	    }
	  }, {
	    key: 'setItalic',
	    value: function setItalic(value) {
	      if (!(value instanceof _RunItalic2.default || value === true || value === null)) {
	        throw TypeError('Invalid RunFormat.italic');
	      }
	      if (value) {
	        value = new _RunItalic2.default();
	      }
	      this.italic = value;
	    }
	  }, {
	    key: 'getItalic',
	    value: function getItalic() {
	      return this.italic;
	    }
	  }, {
	    key: 'addFonts',
	    value: function addFonts() {
	      var rf = new _RunFonts2.default();
	      this.setFonts(rf);
	      return rf;
	    }
	  }, {
	    key: 'setFonts',
	    value: function setFonts(value) {
	      if (!(value instanceof _RunFonts2.default || value === null)) {
	        throw TypeError('Invalid RunFormat.fonts');
	      }
	      this.fonts = value;
	    }
	  }, {
	    key: 'getFonts',
	    value: function getFonts() {
	      return this.fonts;
	    }
	  }, {
	    key: 'addColor',
	    value: function addColor() {
	      var rc = new _RunColor2.default();
	      this.setColor(rc);
	      return rc;
	    }
	  }, {
	    key: 'setColor',
	    value: function setColor(value) {
	      if (!(value instanceof _RunColor2.default || typeof value === 'string' || value === null)) {
	        throw TypeError('Invalid RunFormat.color');
	      }
	      if (typeof value === 'string') {
	        value = new _RunColor2.default(value);
	      }
	      this.color = value;
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.color;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(16);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(42);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _SectionCols = __webpack_require__(35);
	
	var _SectionCols2 = _interopRequireDefault(_SectionCols);
	
	var _SectionType = __webpack_require__(36);
	
	var _SectionType2 = _interopRequireDefault(_SectionType);
	
	var _PageMargins = __webpack_require__(19);
	
	var _PageMargins2 = _interopRequireDefault(_PageMargins);
	
	var _PageSize = __webpack_require__(20);
	
	var _PageSize2 = _interopRequireDefault(_PageSize);
	
	var _Paragraph = __webpack_require__(7);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Table = __webpack_require__(8);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(cols, pgMar, pgSz, type) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:sectPr': {} }, '["w:sectPr"]'));
	
	    _this.setCols(cols || null);
	    _this.setPageMargins(pgMar || null);
	    _this.setPageSize(pgSz || null);
	    _this.setType(type || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'finalize',
	    value: function finalize(contents) {
	      if (this.cols) contents.push(this.cols);
	      if (this.pgMar) contents.push(this.pgMar);
	      if (this.pgSz) contents.push(this.pgSz);
	      if (this.type) contents.push(this.type);
	    }
	  }, {
	    key: 'toJson',
	    value: function toJson() {
	      var realContents = this.contents.filter(function (c) {
	        return c !== null;
	      });
	
	      if (realContents.length > 0) {
	        var patchContents = realContents.map(function (c) {
	          return c.toJson();
	        });
	        var injectedP = new _Paragraph2.default();
	        injectedP.addFormat().contents.push(new _Element3.default(this.src, this.contentHook, [this.cols, this.pgMar, this.pgSz, this.type]));
	        patchContents.push(injectedP.toJson());
	        return JSON.parse((0, _stringify2.default)(patchContents));
	      }
	
	      return (0, _get3.default)(_class.prototype.__proto__ || (0, _getPrototypeOf2.default)(_class.prototype), 'toJson', this).call(this);
	    }
	  }, {
	    key: 'addParagraph',
	    value: function addParagraph() {
	      var p = new _Paragraph2.default();
	      this.contents.push(p);
	      return p;
	    }
	  }, {
	    key: 'addTable',
	    value: function addTable() {
	      var t = new _Table2.default();
	      this.contents.push(t);
	      return t;
	    }
	  }, {
	    key: 'addCols',
	    value: function addCols() {
	      var cols = new _SectionCols2.default();
	      this.setCols(cols);
	      return cols;
	    }
	  }, {
	    key: 'setCols',
	    value: function setCols(value) {
	      if (!(value instanceof _SectionCols2.default || value === null)) {
	        throw TypeError('Invalid Section.cols');
	      }
	      this.cols = value;
	    }
	  }, {
	    key: 'getCols',
	    value: function getCols() {
	      return this.cols;
	    }
	  }, {
	    key: 'addPageMargins',
	    value: function addPageMargins() {
	      var pgMar = new _PageMargins2.default();
	      this.setPageMargins(pgMar);
	      return pgMar;
	    }
	  }, {
	    key: 'setPageMargins',
	    value: function setPageMargins(value) {
	      if (!(value instanceof _PageMargins2.default || value === null)) {
	        throw TypeError('Invalid Section.pgMar');
	      }
	      this.pgMar = value;
	    }
	  }, {
	    key: 'getPageMargins',
	    value: function getPageMargins() {
	      return this.pgMar;
	    }
	  }, {
	    key: 'addPageSize',
	    value: function addPageSize() {
	      var pgSz = new _PageSize2.default();
	      this.setPageSize(pgSz);
	      return pgSz;
	    }
	  }, {
	    key: 'setPageSize',
	    value: function setPageSize(value) {
	      if (!(value instanceof _PageSize2.default || value === null)) {
	        throw TypeError('Invalid Section.pgSz');
	      }
	      this.pgSz = value;
	    }
	  }, {
	    key: 'getPageSize',
	    value: function getPageSize() {
	      return this.pgSz;
	    }
	  }, {
	    key: 'addType',
	    value: function addType() {
	      var t = new _SectionType2.default();
	      this.setType(t);
	      return t;
	    }
	  }, {
	    key: 'setType',
	    value: function setType(value) {
	      if (!(value instanceof _SectionType2.default || value === null)) {
	        throw TypeError('Invalid Section.type');
	      }
	      this.type = value;
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.type;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tblPr': {} }, '["w:tblPr"]'));
	  }
	
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(str, space) {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, {
	      'w:t': {
	        '#': str || null,
	        '@xml:space': space || 'preserve'
	      }
	    }, '["w:t"]'));
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'getString',
	    value: function getString() {
	      return this.src['w:t']['#'];
	    }
	  }, {
	    key: 'setString',
	    value: function setString(str) {
	      this.src['w:t']['#'] = str;
	    }
	  }, {
	    key: 'getSpaceAttr',
	    value: function getSpaceAttr() {
	      return this.src['w:t']['@xml:space'];
	    }
	  }, {
	    key: 'setSpaceAttr',
	    value: function setSpaceAttr(value) {
	      this.src['w:t']['@xml:space'] = value;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/json/stringify");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/object/keys");

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(17);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jszip = __webpack_require__(44);
	
	var _jszip2 = _interopRequireDefault(_jszip);
	
	var _File = __webpack_require__(9);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _Paragraph = __webpack_require__(7);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	var _Table = __webpack_require__(8);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Section = __webpack_require__(13);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function () {
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	
	    this.files = {
	      '_rels/.rels': new _File2.default({
	        "Relationships": {
	          "@xmlns": "http://schemas.openxmlformats.org/package/2006/relationships",
	          "Relationship": {
	            "@Id": "rId1",
	            "@Type": "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
	            "@Target": "word/document.xml"
	          }
	        }
	      }),
	      'word/_rels/document.xml.rels': new _File2.default({
	        "Relationships": { "@xmlns": "http://schemas.openxmlformats.org/package/2006/relationships" }
	      }),
	      'word/document.xml': new _File2.default({
	        "w:document": {
	          "@xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
	          "@xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
	          "@xmlns:o": "urn:schemas-microsoft-com:office:office",
	          "@xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
	          "@xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
	          "@xmlns:v": "urn:schemas-microsoft-com:vml",
	          "@xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
	          "@xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
	          "@xmlns:w10": "urn:schemas-microsoft-com:office:word",
	          "@xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
	          "@xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
	          "@xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
	          "@xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
	          "@xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
	          "@xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
	          "@mc:Ignorable": "w14 wp14",
	          "w:body": {}
	        }
	      }, '["w:document"]["w:body"]'),
	      '[Content_Types].xml': new _File2.default({
	        "Types": {
	          "@xmlns": "http://schemas.openxmlformats.org/package/2006/content-types",
	          "Default": [{
	            "@Extension": "rels",
	            "@ContentType": "application/vnd.openxmlformats-package.relationships+xml"
	          }, {
	            "@Extension": "xml",
	            "@ContentType": "application/xml"
	          }],
	          "Override": {
	            "@PartName": "/word/document.xml",
	            "@ContentType": "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"
	          }
	        }
	      })
	    };
	
	    var r = this.root();
	    r.pageSection = new _Section2.default();
	    r.finalize = function (contents) {
	      contents.push(r.pageSection);
	    };
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'root',
	    value: function root() {
	      return this.files['word/document.xml'];
	    }
	  }, {
	    key: 'addFile',
	    value: function addFile(filename, jsonContent) {
	      var f = new _File2.default(jsonContent);
	      this.files[filename] = f;
	      return f;
	    }
	  }, {
	    key: 'addSection',
	    value: function addSection() {
	      var s = new _Section2.default();
	      this.root().contents.push(s);
	      return s;
	    }
	  }, {
	    key: 'addParagraph',
	    value: function addParagraph() {
	      var p = new _Paragraph2.default();
	      this.root().contents.push(p);
	      return p;
	    }
	  }, {
	    key: 'addTable',
	    value: function addTable() {
	      var t = new _Table2.default();
	      this.root().contents.push(t);
	      return t;
	    }
	  }, {
	    key: 'addCols',
	    value: function addCols() {
	      return this.root().pageSection.addCols();
	    }
	  }, {
	    key: 'addPageMargins',
	    value: function addPageMargins() {
	      return this.root().pageSection.addPageMargins();
	    }
	  }, {
	    key: 'addPageSize',
	    value: function addPageSize() {
	      return this.root().pageSection.addPageSize();
	    }
	  }, {
	    key: 'toZip',
	    value: function toZip() {
	      var _this = this;
	
	      var zip = new _jszip2.default();
	
	      (0, _keys2.default)(this.files).forEach(function (file) {
	        zip.file(file, _this.files[file].toXml());
	      });
	
	      return zip;
	    }
	  }, {
	    key: 'generate',
	    value: function generate(type) {
	      if (!type || typeof type === 'undefined') {
	        type = 'blob';
	      }
	      return this.toZip().generateAsync({
	        type: 'blob',
	        mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
	      });
	    }
	  }]);
	  return _class;
	}();

	exports.default = _class;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(bottom, footer, gutter, header, left, right, top) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:pgMar': {} }));
	
	    if (bottom) _this.setBottom(bottom || null);
	    if (footer) _this.setFooter(footer || null);
	    if (gutter) _this.setGutter(gutter || null);
	    if (header) _this.setHeader(header || null);
	    if (left) _this.setLeft(left || null);
	    if (right) _this.setRight(right || null);
	    if (top) _this.setTop(top || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setBottom',
	    value: function setBottom(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:bottom'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:bottom'];
	      }
	    }
	  }, {
	    key: 'getBottom',
	    value: function getBottom() {
	      return this.src['w:pgMar']['@w:bottom'] || null;
	    }
	  }, {
	    key: 'setFooter',
	    value: function setFooter(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:footer'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:footer'];
	      }
	    }
	  }, {
	    key: 'getFooter',
	    value: function getFooter() {
	      return this.src['w:pgMar']['@w:footer'] || null;
	    }
	  }, {
	    key: 'setGutter',
	    value: function setGutter(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:gutter'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:gutter'];
	      }
	    }
	  }, {
	    key: 'getGutter',
	    value: function getGutter() {
	      return this.src['w:pgMar']['@w:gutter'] || null;
	    }
	  }, {
	    key: 'setHeader',
	    value: function setHeader(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:header'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:header'];
	      }
	    }
	  }, {
	    key: 'getHeader',
	    value: function getHeader() {
	      return this.src['w:pgMar']['@w:header'] || null;
	    }
	  }, {
	    key: 'setLeft',
	    value: function setLeft(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:left'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:left'];
	      }
	    }
	  }, {
	    key: 'getLeft',
	    value: function getLeft() {
	      return this.src['w:pgMar']['@w:left'] || null;
	    }
	  }, {
	    key: 'setRight',
	    value: function setRight(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:right'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:right'];
	      }
	    }
	  }, {
	    key: 'getRight',
	    value: function getRight() {
	      return this.src['w:pgMar']['@w:right'] || null;
	    }
	  }, {
	    key: 'setTop',
	    value: function setTop(value) {
	      if (value) {
	        this.src['w:pgMar']['@w:top'] = value;
	      } else {
	        delete this.src['w:pgMar']['@w:top'];
	      }
	    }
	  }, {
	    key: 'getTop',
	    value: function getTop() {
	      return this.src['w:pgMar']['@w:top'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(w, h, orient) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:pgSz': {} }));
	
	    if (w) _this.setW(bottom || null);
	    if (h) _this.setH(footer || null);
	    if (orient) _this.setOrient(orient || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setW',
	    value: function setW(value) {
	      if (value) {
	        this.src['w:pgSz']['@w:w'] = value;
	      } else {
	        delete this.src['w:pgSz']['@w:w'];
	      }
	    }
	  }, {
	    key: 'getW',
	    value: function getW() {
	      return this.src['w:pgSz']['@w:w'] || null;
	    }
	  }, {
	    key: 'setH',
	    value: function setH(value) {
	      if (value) {
	        this.src['w:pgSz']['@w:h'] = value;
	      } else {
	        delete this.src['w:pgSz']['@w:h'];
	      }
	    }
	  }, {
	    key: 'getH',
	    value: function getH() {
	      return this.src['w:pgSz']['@w:h'] || null;
	    }
	  }, {
	    key: 'setOrient',
	    value: function setOrient(value) {
	      if (value) {
	        this.src['w:pgSz']['@w:orient'] = value;
	      } else {
	        delete this.src['w:pgSz']['@w:orient'];
	      }
	    }
	  }, {
	    key: 'getOrient',
	    value: function getOrient() {
	      return this.src['w:pgSz']['@w:orient'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(val) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:jc': {} }, '["w:jc"]'));
	
	    if (val) _this.setVal(val || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setVal',
	    value: function setVal(value) {
	      if (value) {
	        this.src['w:jc']['@w:val'] = value;
	      } else {
	        delete this.src['w:jc']['@w:val'];
	      }
	    }
	  }, {
	    key: 'getVal',
	    value: function getVal() {
	      return this.src['w:jc']['@w:val'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(left, right, hanging, firstLine) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:ind': {} }));
	
	    if (left) _this.setLeft(left || null);
	    if (right) _this.setRight(right || null);
	    if (hanging) _this.setHanging(hanging || null);
	    if (firstLine) _this.setFirstLine(firstLine || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setLeft',
	    value: function setLeft(value) {
	      if (value) {
	        this.src['w:ind']['@w:left'] = value;
	      } else {
	        delete this.src['w:ind']['@w:left'];
	      }
	    }
	  }, {
	    key: 'getLeft',
	    value: function getLeft() {
	      return this.src['w:ind']['@w:left'] || null;
	    }
	  }, {
	    key: 'setRight',
	    value: function setRight(value) {
	      if (value) {
	        this.src['w:ind']['@w:right'] = value;
	      } else {
	        delete this.src['w:ind']['@w:right'];
	      }
	    }
	  }, {
	    key: 'getRight',
	    value: function getRight() {
	      return this.src['w:ind']['@w:right'] || null;
	    }
	  }, {
	    key: 'setHanging',
	    value: function setHanging(value) {
	      if (value) {
	        this.src['w:ind']['@w:hanging'] = value;
	      } else {
	        delete this.src['w:ind']['@w:hanging'];
	      }
	    }
	  }, {
	    key: 'getHanging',
	    value: function getHanging() {
	      return this.src['w:ind']['@w:hanging'] || null;
	    }
	  }, {
	    key: 'setFirstLine',
	    value: function setFirstLine(value) {
	      if (value) {
	        this.src['w:ind']['@w:firstLine'] = value;
	      } else {
	        delete this.src['w:ind']['@w:firstLine'];
	      }
	    }
	  }, {
	    key: 'getFirstLine',
	    value: function getFirstLine() {
	      return this.src['w:ind']['@w:firstLine'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:keepLines': null }));
	  }
	
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:keepNext': null }));
	  }
	
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(fill, color, val) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:shd': {} }));
	
	    if (fill) _this.setFill(fill || null);
	    if (color) _this.setColor(color || null);
	    if (val) _this.setVal(val || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setFill',
	    value: function setFill(value) {
	      if (value) {
	        this.src['w:shd']['@w:fill'] = value;
	      } else {
	        delete this.src['w:shd']['@w:fill'];
	      }
	    }
	  }, {
	    key: 'getFill',
	    value: function getFill() {
	      return this.src['w:shd']['@w:fill'] || null;
	    }
	  }, {
	    key: 'setColor',
	    value: function setColor(value) {
	      if (value) {
	        this.src['w:shd']['@w:color'] = value;
	      } else {
	        delete this.src['w:shd']['@w:color'];
	      }
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.src['w:shd']['@w:color'] || null;
	    }
	  }, {
	    key: 'setVal',
	    value: function setVal(value) {
	      if (value) {
	        this.src['w:shd']['@w:val'] = value;
	      } else {
	        delete this.src['w:shd']['@w:val'];
	      }
	    }
	  }, {
	    key: 'getVal',
	    value: function getVal() {
	      return this.src['w:shd']['@w:val'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(after, before, line, lineRule, beforeAutospacing, afterAutospacing) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:spacing': null }));
	
	    if (after) _this.setAfter(after || null);
	    if (before) _this.setBefore(before || null);
	    if (line) _this.setLine(line || null);
	    if (lineRule) _this.setLineRule(lineRule || null);
	    if (beforeAutospacing) _this.setBeforeAutospacing(beforeAutospacing || null);
	    if (afterAutospacing) _this.setAfterAutospacing(afterAutospacing || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setAfter',
	    value: function setAfter(value) {
	      if (value) {
	        this.src['w:spacing']['@w:after'] = value;
	      } else {
	        delete this.src['w:spacing']['@w:after'];
	      }
	    }
	  }, {
	    key: 'getAfter',
	    value: function getAfter() {
	      return this.src['w:spacing']['@w:after'] || null;
	    }
	  }, {
	    key: 'setBefore',
	    value: function setBefore(value) {
	      if (value) {
	        this.src['w:spacing']['@w:before'] = value;
	      } else {
	        delete this.src['w:spacing']['@w:before'];
	      }
	    }
	  }, {
	    key: 'getBefore',
	    value: function getBefore() {
	      return this.src['w:spacing']['@w:before'] || null;
	    }
	  }, {
	    key: 'setLine',
	    value: function setLine(value) {
	      if (value) {
	        this.src['w:spacing']['@w:line'] = value;
	      } else {
	        delete this.src['w:spacing']['@w:line'];
	      }
	    }
	  }, {
	    key: 'getLineRule',
	    value: function getLineRule() {
	      return this.src['w:spacing']['@w:lineRule'] || null;
	    }
	  }, {
	    key: 'setLineRule',
	    value: function setLineRule(value) {
	      if (value) {
	        this.src['w:spacing']['@w:lineRule'] = value;
	      } else {
	        delete this.src['w:spacing']['@w:lineRule'];
	      }
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine() {
	      return this.src['w:spacing']['@w:line'] || null;
	    }
	  }, {
	    key: 'setAfterAutospacing',
	    value: function setAfterAutospacing(value) {
	      if (value) {
	        this.src['w:spacing']['@w:afterAutospacing'] = value;
	      } else {
	        delete this.src['w:spacing']['@w:afterAutospacing'];
	      }
	    }
	  }, {
	    key: 'getAfterAutospacing',
	    value: function getAfterAutospacing() {
	      return this.src['w:spacing']['@w:afterAutospacing'] || null;
	    }
	  }, {
	    key: 'setBeforeAutospacing',
	    value: function setBeforeAutospacing(value) {
	      if (value) {
	        this.src['w:spacing']['@w:beforeAutospacing'] = value;
	      } else {
	        delete this.src['w:spacing']['@w:beforeAutospacing'];
	      }
	    }
	  }, {
	    key: 'getBeforeAutospacing',
	    value: function getBeforeAutospacing() {
	      return this.src['w:spacing']['@w:beforeAutospacing'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(leader, pos, val) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tab': null }));
	
	    if (leader) _this.setLeader(leader || null);
	    if (pos) _this.setPos(pos || null);
	    if (val) _this.setVal(val || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setLeader',
	    value: function setLeader(value) {
	      if (value) {
	        this.src['w:tab']['@w:leader'] = value;
	      } else {
	        delete this.src['w:tab']['@w:leader'];
	      }
	    }
	  }, {
	    key: 'getLeader',
	    value: function getLeader() {
	      return this.src['w:tab']['@w:leader'] || null;
	    }
	  }, {
	    key: 'setPos',
	    value: function setPos(value) {
	      if (value) {
	        this.src['w:tab']['@w:pos'] = value;
	      } else {
	        delete this.src['w:tab']['@w:pos'];
	      }
	    }
	  }, {
	    key: 'getPos',
	    value: function getPos() {
	      return this.src['w:tab']['@w:pos'] || null;
	    }
	  }, {
	    key: 'setVal',
	    value: function setVal(value) {
	      if (value) {
	        this.src['w:tab']['@w:val'] = value;
	      } else {
	        delete this.src['w:tab']['@w:val'];
	      }
	    }
	  }, {
	    key: 'getVal',
	    value: function getVal() {
	      return this.src['w:tab']['@w:val'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _ParagraphTab = __webpack_require__(27);
	
	var _ParagraphTab2 = _interopRequireDefault(_ParagraphTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tabs': {} }, '["w:tabs"]'));
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'addTab',
	    value: function addTab(tab) {
	      var t = new _ParagraphTab2.default();
	      this.contents.push(t);
	      return t;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(val) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:textAlignment': {} }, '["w:textAlignment"]'));
	
	    if (val) _this.setVal(val || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setVal',
	    value: function setVal(value) {
	      if (value) {
	        this.src['w:textAlignment']['@w:val'] = value;
	      } else {
	        delete this.src['w:textAlignment']['@w:val'];
	      }
	    }
	  }, {
	    key: 'getVal',
	    value: function getVal() {
	      return this.src['w:textAlignment']['@w:val'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:b': null }));
	  }
	
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(type, clear) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:br': { '#': null } }));
	
	    if (type) _this.setType(type || null);
	    if (clear) _this.setClear(clear || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setType',
	    value: function setType(value) {
	      if (value) {
	        this.src['w:br']['@w:type'] = value;
	      } else {
	        delete this.src['w:br']['@w:type'];
	      }
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.src['w:br']['@w:type'] || null;
	    }
	  }, {
	    key: 'setClear',
	    value: function setClear(value) {
	      if (value) {
	        this.src['w:br']['@w:clear'] = value;
	      } else {
	        delete this.src['w:br']['@w:clear'];
	      }
	    }
	  }, {
	    key: 'getClear',
	    value: function getClear() {
	      return this.src['w:br']['@w:clear'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(val) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:color': {} }));
	
	    if (val) _this.setVal(val || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setVal',
	    value: function setVal(value) {
	      if (value) {
	        this.src['w:color']['@w:val'] = value;
	      } else {
	        delete this.src['w:color']['@w:val'];
	      }
	    }
	  }, {
	    key: 'getVal',
	    value: function getVal() {
	      return this.src['w:color']['@w:val'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(ascii, cs, eastAsia, hAnsi) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:rFonts': {} }));
	
	    if (ascii) _this.setAscii(ascii || null);
	    if (cs) _this.setCs(cs || null);
	    if (eastAsia) _this.setEastAsia(eastAsia || null);
	    if (hAnsi) _this.setHAnsi(hAnsi || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setAscii',
	    value: function setAscii(value) {
	      if (value) {
	        this.src['w:rFonts']['@w:ascii'] = value;
	      } else {
	        delete this.src['w:rFonts']['@w:ascii'];
	      }
	    }
	  }, {
	    key: 'getAscii',
	    value: function getAscii() {
	      return this.src['w:rFonts']['@w:ascii'] || null;
	    }
	  }, {
	    key: 'setCs',
	    value: function setCs(value) {
	      if (value) {
	        this.src['w:rFonts']['@w:cs'] = value;
	      } else {
	        delete this.src['w:rFonts']['@w:cs'];
	      }
	    }
	  }, {
	    key: 'getCs',
	    value: function getCs() {
	      return this.src['w:rFonts']['@w:cs'] || null;
	    }
	  }, {
	    key: 'setEastAsia',
	    value: function setEastAsia(value) {
	      if (value) {
	        this.src['w:rFonts']['@w:eastAsia'] = value;
	      } else {
	        delete this.src['w:rFonts']['@w:eastAsia'];
	      }
	    }
	  }, {
	    key: 'getEastAsia',
	    value: function getEastAsia() {
	      return this.src['w:rFonts']['@w:eastAsia'] || null;
	    }
	  }, {
	    key: 'setHAnsi',
	    value: function setHAnsi(value) {
	      if (value) {
	        this.src['w:rFonts']['@w:hAnsi'] = value;
	      } else {
	        delete this.src['w:rFonts']['@w:hAnsi'];
	      }
	    }
	  }, {
	    key: 'getHAnsi',
	    value: function getHAnsi() {
	      return this.src['w:rFonts']['@w:hAnsi'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:i': null }));
	  }
	
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(equalWidth, num, sep, space) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:cols': {} }));
	
	    _this.setEqualWidth(equalWidth || null);
	    _this.setNum(num || null);
	    _this.setSep(sep || null);
	    _this.setSpace(space || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setEqualWidth',
	    value: function setEqualWidth(value) {
	      if (value) {
	        this.src['w:cols']['@w:equalWidth'] = value;
	      } else {
	        delete this.src['w:cols']['@w:equalWidth'];
	      }
	    }
	  }, {
	    key: 'getEqualWidth',
	    value: function getEqualWidth() {
	      return this.src['w:cols']['@w:equalWidth'] || null;
	    }
	  }, {
	    key: 'setNum',
	    value: function setNum(value) {
	      if (value) {
	        this.src['w:cols']['@w:num'] = value;
	      } else {
	        delete this.src['w:cols']['@w:num'];
	      }
	    }
	  }, {
	    key: 'getNum',
	    value: function getNum() {
	      return this.src['w:cols']['@w:num'] || null;
	    }
	  }, {
	    key: 'setSep',
	    value: function setSep(value) {
	      if (value) {
	        this.src['w:cols']['@w:sep'] = value;
	      } else {
	        delete this.src['w:cols']['@w:sep'];
	      }
	    }
	  }, {
	    key: 'getSep',
	    value: function getSep() {
	      return this.src['w:cols']['@w:sep'] || null;
	    }
	  }, {
	    key: 'setSpace',
	    value: function setSpace(value) {
	      if (value) {
	        this.src['w:cols']['@w:space'] = value;
	      } else {
	        delete this.src['w:cols']['@w:space'];
	      }
	    }
	  }, {
	    key: 'getSpace',
	    value: function getSpace() {
	      return this.src['w:cols']['@w:space'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class(val) {
	    (0, _classCallCheck3.default)(this, _class);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:type': {} }));
	
	    if (val) _this.setVal(val || null);
	    return _this;
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'setVal',
	    value: function setVal(value) {
	      if (value) {
	        this.src['w:type']['@w:val'] = value;
	      } else {
	        delete this.src['w:type']['@w:val'];
	      }
	    }
	  }, {
	    key: 'getVal',
	    value: function getVal() {
	      return this.src['w:type']['@w:val'] || null;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _Paragraph = __webpack_require__(7);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tc': {} }, '["w:tc"]'));
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'addParagraph',
	    value: function addParagraph() {
	      var p = new _Paragraph2.default();
	      this.contents.push(p);
	      return p;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _TableHeaderColumn = __webpack_require__(39);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tblGrid': {} }, '["w:tblGrid"]'));
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'addColumn',
	    value: function addColumn() {
	      var col = new _TableHeaderColumn2.default();
	      this.contents.push(col);
	      return col;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _Paragraph = __webpack_require__(7);
	
	var _Paragraph2 = _interopRequireDefault(_Paragraph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:gridCol': {} }, '["w:gridCol"]'));
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'addParagraph',
	    value: function addParagraph() {
	      var p = new _Paragraph2.default();
	      this.contents.push(p);
	      return p;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(3);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Element2 = __webpack_require__(2);
	
	var _Element3 = _interopRequireDefault(_Element2);
	
	var _TableColumn = __webpack_require__(37);
	
	var _TableColumn2 = _interopRequireDefault(_TableColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function (_Element) {
	  (0, _inherits3.default)(_class, _Element);
	
	  function _class() {
	    (0, _classCallCheck3.default)(this, _class);
	    return (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call(this, { 'w:tr': {} }, '["w:tr"]'));
	  }
	
	  (0, _createClass3.default)(_class, [{
	    key: 'addColumn',
	    value: function addColumn() {
	      var col = new _TableColumn2.default();
	      this.contents.push(col);
	      return col;
	    }
	  }]);
	  return _class;
	}(_Element3.default);

	exports.default = _class;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/core-js/object/assign");

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/get");

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = require("babel-runtime/helpers/typeof");

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	module.exports = require("jszip");

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	module.exports = require("to-xml");

/***/ })
/******/ ])
});
;
//# sourceMappingURL=jsdocx.js.map


//////////////////
// WEBPACK FOOTER
// ./~/jsdocx/dist/jsdocx.js
// module id = 1166
// module chunks = 0